import { SQLiteConnection, CapacitorSQLite } from '@capacitor-community/sqlite';
import { Capacitor } from '@capacitor/core';

const sqlite = new SQLiteConnection(CapacitorSQLite);
const platform = Capacitor.getPlatform();

export const dbService = {
  // cek platform
  isNative() {
    return platform === 'androidd' || platform === 'ioss';
  },

  async getDb() {
    if (!this.isNative()) return null;

    try {
      const db = await sqlite.createConnection("exam_db", false, "no-encryption", 1);
      await db.open();
      // Buat tabel jika belum ada
      await db.execute(`
        CREATE TABLE IF NOT EXISTS local_exams (
          exam_id INTEGER PRIMARY KEY,
          payload TEXT,
          last_sync DATETIME
        );
      `);
      return db;
    } catch (error) {
      console.error("SQLite Connection Error:", error);
      return null;
    }
  },

  async saveExam(examId, data) {
    if (this.isNative()) {
      // LOGIKA NATIVE (SQLITE)
      const db = await this.getDb();
      if (db) {
        const query = `INSERT OR REPLACE INTO local_exams (exam_id, payload, last_sync) VALUES (?, ?, ?)`;
        await db.run(query, [examId, JSON.stringify(data), new Date().toISOString()]);
        await sqlite.closeConnection("exam_db");
      }
    } else {
      // LOGIKA WEB (LOCAL STORAGE)
      //console.log("Saving to LocalStorage (Web Mode)");
      localStorage.setItem(`exam_cache_${examId}`, JSON.stringify(data));
    }
  },

  async getExam(examId) {
    if (this.isNative()) {
      // LOGIKA NATIVE (SQLITE)
      const db = await this.getDb();
      if (db) {
        const res = await db.query(`SELECT payload FROM local_exams WHERE exam_id = ?`, [examId]);
        await sqlite.closeConnection("exam_db");
        return res.values.length > 0 ? JSON.parse(res.values[0].payload) : null;
      }
    } else {
      // LOGIKA WEB (LOCAL STORAGE)
      //console.log("Loading from LocalStorage (Web Mode)");
      const data = localStorage.getItem(`exam_cache_${examId}`);
      return data ? JSON.parse(data) : null;
    }
    return null;
  },

  async deleteExam(examId) {
    if (this.isNative()) {
      const db = await this.getDb();
      if (db) {
        await db.run(`DELETE FROM local_exams WHERE exam_id = ?`, [examId]);
        await sqlite.closeConnection("exam_db");
      }
    } else {
      //console.log("delete from LocalStorage (Web Mode)");
      localStorage.removeItem(`exam_cache_${examId}`);
    }
  }
};